/** One-shot scale absorb for CircleButton status changes. */
export const CIRCLE_BUTTON_STATUS_ABSORB = {
	from: 1,
	peak: 1.08,
	to: 1,
	durationMs: 320,
} as const;

export const CIRCLE_BUTTON_NOTIFY_PULSE_COLORS = {
	red: "rgba(239, 68, 68, 0.65)",
	amber: "rgba(245, 158, 11, 0.65)",
	green: "rgba(34, 197, 94, 0.65)",
} as const;

export type CircleButtonNotifyPulseColor =
	keyof typeof CIRCLE_BUTTON_NOTIFY_PULSE_COLORS;
